/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Input } from 'antd';
import React, { useMemo } from 'react';
import { commonHelpers } from 'utilities/helpers';

type props = {
    style?: React.CSSProperties;
    name?: string;
    placeholder?: string;
    suffix?: any;
    prefix?: any;
    disabled?: any;
    maxLength?: number;
    required?: boolean;
    Value?: number | string;
    fraction?: boolean;
    callback?: Function;
    subtract?: boolean;
    onChange?: (value: number | string) => void;
};

const PrefixOrSuffixInput = ({
    placeholder,
    suffix,
    prefix,
    disabled,
    style,
    maxLength,
    Value,
    fraction,
    callback,
    subtract,
    onChange,
}: props) => {
    const onBlur = (e: any) => {
        // convert number full size to half size
        let val = commonHelpers.toASCII(e.target.value);
        if (val === '') {
            onChange && onChange(val);
            return;
        }
        val = commonHelpers.toNumberOnly(val);
        if (val.includes(',')) {
            val = val.replaceAll(',', '');
        }
        if (onChange) {
            if (val.includes('.')) {
                onChange(val);
                return;
            } else if (val === '-') {
                onChange('');
                return;
            } else {
                onChange(Number(val).toLocaleString('en-US', { maximumFractionDigits: 1 }));
            }
        }
    };

    const handleClick = (e: any) => {
        if (onChange && e.target.value !== '') onChange(e.target.value.replaceAll(',', ''));
    };

    const maxLengthCalc = useMemo(() => {
        if (maxLength) {
            if (Value) {
                if ((Value + '').includes('.')) {
                    return maxLength + 1;
                }
            }
        }
        return maxLength;
    }, [maxLength, Value]);

    const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
        const charCode = e.charCode;
        const char = String.fromCharCode(charCode);

        // Allow only digits and necessary keys
        if (!/^\d$/.test(char) && char !== '-' && char !== '.' && charCode !== 13) {
            e.preventDefault();
        }
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        const sanitizedValue = value.replace(/[^0-9.-]/g, '');

        if (onChange) {
            onChange(sanitizedValue);
            callback && callback(sanitizedValue);
        }
    };

    return (
        <Input
            style={style}
            value={Value}
            placeholder={placeholder}
            suffix={suffix}
            prefix={prefix}
            disabled={disabled}
            maxLength={maxLengthCalc}
            onKeyPress={handleKeyPress}
            onBlur={onBlur}
            onChange={handleChange}
            onClick={handleClick}
        />
    );
};

export default PrefixOrSuffixInput;
